import { CAMPAIGN_ACTION } from '../../constants/actions'

const changeCampaignState = (property, value) => ({
  type: CAMPAIGN_ACTION.CHANGE_STATE,
  payload: {
    property,
    value
  }
})

const changeCampaignListState = (property, value) => ({
  type: CAMPAIGN_ACTION.CHANGE_LIST_STATE,
  payload: {
    property,
    value
  }
})

const createCampaign = () => {
  return {
    type: CAMPAIGN_ACTION.ON_CREATE_CAMPAIGN
  }
}

const toggleCampaign = (id, data) => {
  return {
    type: CAMPAIGN_ACTION.ON_TOGGLE_CAMPAIGN,
    payload: {
      campaign: { id, data }
    }
  }
}

const resetCampaignState = () => ({
  type: CAMPAIGN_ACTION.RESET_STATE
})

const getCampaigns = (payload) => ({
  type: CAMPAIGN_ACTION.ON_GET_CAMPAIGNS,
  payload
})

const resetCampaignsList = () => ({
  type: CAMPAIGN_ACTION.ON_RESET_LIST
})

const selectCampaign = (data, isListUpdate = false) => ({
  type: CAMPAIGN_ACTION.ON_SELECT,
  payload: { data, isListUpdate }
})

const downloadCampaignsCSV = (campaign) => ({
  type: CAMPAIGN_ACTION.ON_SEND_REPORT_IN_EMAIL,
  payload: campaign
})

export {
  changeCampaignState,
  changeCampaignListState,
  createCampaign,
  resetCampaignState,
  getCampaigns,
  toggleCampaign,
  resetCampaignsList,
  selectCampaign,
  downloadCampaignsCSV
}
